import styled from 'styled-components';
import media from 'styled-media-query';

import { LpInner } from '../../../atoms/lp/LpInner';
import { LpTitle } from '../../../atoms/lp/LpTitle';

import GiftImage from '../../../../static/image/lp/gift001.png';

export const LpAdGift = (): JSX.Element => {
  return (
    <Gift data-gtm="gift">
      <LpInner>
        <LpTitle>
          <h2>登録特典</h2>
          <p>Gift</p>
        </LpTitle>
        <img src={GiftImage} alt="登録者限定！「SAMURAI式プログラミング学習メソッド」をプレゼント！" />
      </LpInner>
    </Gift>
  );
};

const Gift = styled.section`
  padding: 6.25rem 0;
  background: #f5f0ed;

  img {
    display: block;
    width: 100%;
    max-width: 802px;
    margin: 4rem auto 0;
  }

  ${media.lessThan('medium')`
    padding: 4rem 0;

    img {
      margin-top: 2rem;
    }
  `}
`;
